import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import React from "react";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { Card, CardBody } from "reactstrap";
import BloodCollectionOrderForm, {
  BLOOD_COLLECTION_ORDER_FORM_MODE,
  BLOOD_COLLECTION_ORDER_FORM_ROLE_MODE,
} from "../BloodCollectionOrderForm";
import { useCheckRole, useMyHubsList } from "hooks";

const CreateBloodCollectionOrderPage = () => {
  const { t } = useTranslation(["bloodOrder"]);
  const { isHubAdmin, isLogAdmin } = useCheckRole();
  const { data: myHubs } = useMyHubsList();
  return (
    <div
      className="page-content"
      style={{
        minHeight: "102vh",
      }}
    >
      <MetaTags>
        <title>{t("title.create")}</title>
      </MetaTags>
      <div className="container-fluid">
        <BreadcrumbWithLink
          title={t("title.create")}
          breadcrumbItems={[
            { name: t("title.manager") },
            { name: t("title.create") },
          ]}
        />
        <Card>
          <CardBody>
            <BloodCollectionOrderForm
              roleMode={
                isHubAdmin || isLogAdmin
                  ? BLOOD_COLLECTION_ORDER_FORM_ROLE_MODE.ADMIN
                  : BLOOD_COLLECTION_ORDER_FORM_ROLE_MODE.SALE
              }
              formMode={BLOOD_COLLECTION_ORDER_FORM_MODE.CREATE}
              saleHubId={myHubs?.hub?.id}
            />
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default CreateBloodCollectionOrderPage;
